import ClientService from '../../services/client-service';
import getDealListDataQuery from '../../graphql/query/get-deal-list-data.graphql';
import getDealStatusChangeListDataQuery from '../../graphql/query/get-deal-status-change-list-data.graphql';
import deleteDealListMutation from '../../graphql/mutation/delete-deal-list.graphql';
import shareDealDataMutation from '../../graphql/mutation/share-deal-data.graphql';
import updateFileDealListMutation from '../../graphql/mutation/update-file-deal-list.graphql';
import saveDealListDataMutation from '../../graphql/mutation/save-deal-list-data.graphql';
import saveDealStatusListMutation from '../../graphql/mutation/save-deal-status-list.graphql';
import saveDealListFileMutation from '../../graphql/mutation/save-deal-list-file.graphql';

export default class DealListApi {
  public static getDealListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealListDataQuery, payload);
  }

  public static getDealStatusChangeListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getDealStatusChangeListDataQuery, payload);
  }

  public static deleteDealList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteDealListMutation, payload);
  }

  public static shareDealData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(shareDealDataMutation, payload);
  }

  public static updateFileDealList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(updateFileDealListMutation, payload);
  }

  public static saveDealListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealListDataMutation, payload);
  }

  public static saveDealStatusList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealStatusListMutation, payload);
  }

  public static saveDealListFile(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveDealListFileMutation, payload);
  }
}
